(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-font-size-resizer", [], factory);
	else if(typeof exports === 'object')
		exports["react-font-size-resizer"] = factory();
	else
		root["react-font-size-resizer"] = factory();
})(window, function() {
return 